import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES } from '@/utils/constants';
import {
  password,
  required,
  sameAsPassword,
} from '@/utils/validators';

export default {
  name: 'ResetPassword',
  props: {
    open: {
      default: false,
      type: Boolean,
    },
  },
  setup() {
    return { resetPwdValidator$: useVuelidate({ $lazy: true }) };
  },
  data() {
    return {
      confirmPassword: '',
      currentPassword: '',
      password: '',
    };
  },
  computed: {
    ...mapState('user', {
      updating: ({ updatingUser }) => updatingUser,
    }),
    fields() {
      return [
        {
          key: 'currentPassword',
          label: '目前密碼',
        },
        {
          hint: '密碼長度必須8個字元以上，並且其中必須含英文字母及數字',
          key: 'password',
          label: '密碼',
        },
        {
          key: 'confirmPassword',
          label: '確認新密碼',
        },
      ];
    },
  },
  methods: {
    ...mapActions('user', {
      updateUser: 'UPDATE_USER',
    }),
    async updatePassword() {
      const valid = await this.resetPwdValidator$.$validate();
      if (!valid) return;

      try {
        await this.updateUser({
          old_password: this.currentPassword,
          new_password: this.confirmPassword,
        });
        this.$snackbar({ type: SNACKBAR_TYPES.SUCCESS, title: '變更密碼成功！' });
        this.close();
      } catch (error) {
        const { message: msg } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '變更密碼失敗',
          msg,
        });
      }
    },
    close() {
      this.confirmPassword = '';
      this.currentPassword = '';
      this.password = '';
      this.resetPwdValidator$.$reset();
      this.$emit('close');
    },
    getErrorMsgs(field) {
      return this.resetPwdValidator$[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return !!this.resetPwdValidator$[field]?.$errors?.length;
    },
  },
  validations() {
    return {
      confirmPassword: { required: required('確認密碼'), sameAsPassword: sameAsPassword(() => this.password) },
      currentPassword: { required: required('目前密碼'), password },
      password: { required: required('新密碼'), password },
    };
  },
};
